import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Section from '../Atoms/Section';

const FormsContainer = styled(Section)`
  padding: 40px 20px;
  min-height: calc(100vh - 200px);
  max-width: 1200px;
  margin: 0 auto;
  background-color: #f5f5f5;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 2.5rem;
  font-size: 2.5rem;
  color: #333;
  font-weight: 600;
`;

const FormsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 30px;
`;

const FormCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: #0000FF;
    transform: translateY(-100%);
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    border-color: #0000FF;

    &:before {
      transform: translateY(0);
    }
  }
`;

const FormIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #0000FF 0%, #0000CC 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 2rem;
  color: white;
  font-size: 36px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(0, 0, 255, 0.2);
`;

const FormTitle = styled.h3`
  font-size: 1.8rem;
  margin-bottom: 1rem;
  color: #1a1a1a;
  font-weight: 600;
`;

const FormDescription = styled.p`
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  flex-grow: 1;
`;

const FormButton = styled.button`
  background: #0000FF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px 35px;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: #0000CC;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 255, 0.3);
  }
`;

const Forms = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  const handleFormClick = (formPath) => {
    navigate(formPath);
  };

  return (
    <FormsContainer>
      <Title>{isEn ? 'Forms' : 'Formulaires'}</Title>
      <FormsGrid>
        <FormCard onClick={() => handleFormClick('/forms/milan-2026')}>
          <FormIcon>M</FormIcon>
          <FormTitle>Projet Milan 2026</FormTitle>
          <FormDescription>
            {isEn 
              ? "Submit your application for the Milan 2026 furniture and design exhibition"
              : "Soumettez votre candidature pour l'exposition de mobilier et design Milan 2026"}
          </FormDescription>
          <FormButton>
            {isEn ? 'Apply Now' : 'Candidater'}
          </FormButton>
        </FormCard>
      </FormsGrid>
    </FormsContainer>
  );
};

export default Forms;